module.exports = __webpack_public_path__ + "img/botones_pulsadores.605bb908.jpg";